<template>
  <section>
    <b-field label="Username">
      <b-input v-model="currentUser.username" readonly/>
    </b-field>
    <b-field label="Email">
      <b-input v-model="currentUser.email" readonly/>
    </b-field>
    <b-field label="Contact">
      <b-input v-model="currentUser.contact" readonly/>
    </b-field>
    <b-field label="Full Name">
      <b-input v-model="currentUser.name" readonly/>
    </b-field>
    <b-field label="Role">
      <b-input v-model="currentUser.role" readonly/>
    </b-field>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'AccountPage',
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>
